const E500 = () => (
  <div className="error-container error-500">
    <h1>500</h1>
    <p className="title">Internal Server Error</p>
    <p>Oops! Something went wrong on our end. Please try again later.</p>
  </div>
);

export default E500;